import axios from 'axios';
import { adaptDrilldownFilters } from './adapters/filterAdapters';
import errorHandlerFactory from './errorHandler';

const errorHandler = errorHandlerFactory('An error occured when fetching CSA Drilldowns.');

// eslint-disable-next-line import/prefer-default-export
export const csaDrilldowns = (filters = []) => {
    const filterObject = adaptDrilldownFilters(filters);
    // If the filter object isn't empty
    if (!(Object.entries(filterObject).length === 0)) {
        return axios.post('/Csa/CsaDrilldown', filterObject)
            .then(r => r.data).catch(errorHandler);
    }
    throw Error('A CSA filter is required');
};
